import { $host } from './index';

// Запросы для работы с опросами
export const fetchSurveys = async () => {
  const { data } = await $host.get('web/surveys/');
  return data;
};

export const fetchOneSurvey = async (id) => {
  const { data } = await $host.get('web/surveys/' + id);
  return data;
};

export const createSurvey = async (survey) => {
  const { data } = await $host.post('web/surveys/', survey);
  return data;
};

export const updateSurvey = async (id, survey) => {
  const { data } = await $host.put('web/surveys/' + id, survey);
  return data;
};

export const deleteSurvey = async (id) => {
  const { data } = await $host.delete('web/surveys/' + id);
  return data;
};
